// extracted by mini-css-extract-plugin
module.exports = {"infoPanel":"InfoPanel_infoPanel__3CX7H","infoPanelMobile":"InfoPanel_infoPanelMobile__8z6Nv","infoPanelContent":"InfoPanel_infoPanelContent__3JSjv"};